// Libs
import React from 'react';
import moment from 'moment';

// Services
import TodoService from 'services/TodoService';

//-------------------------------------------------------------------------------------------------------------------

class TodosTable extends React.Component {

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        // Re-render if different request ID
        if (nextProps.requestID != this.props.requestID) {
            return true;
        }
        return false;
    }

    render() {
        const {
            todos,
            onSelect
        } = this.props;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const getRowClass = (todo) => {
            const date = new Date(todo.date);
            if (date == today) {
                return 'todo-due';
            } else if (date >= today) {
                return 'todo-not-due';
            } else {
                return 'todo-overdue';
            }
            return '';
        }

        if (todos.length == 0) {
            return (
                <div className="empty-text">
                    Sorry, no to-dos were found. Ask your boss for more work to do!
                </div>
            );
        }

        return (

            <table className="table table-bordered todos-table selectable mb-0">
                <thead>
                    <tr>
                        <th className="type-column">Type</th>
                        <th className="description-column">Description</th>
                        <th className="assigned-to-column">Assigned to</th>
                        <th className="date-due-column">Date due</th>
                    </tr>
                </thead>
                <tbody>
                    {todos.map((todo, index) =>
                        <React.Fragment key={todo.id}>
                            <tr className={getRowClass(todo)} onClick={e => onSelect(todo)}>
                                <td className="type-column">{TodoService.getTypeName(todo.type)}</td>
                                <td className="description-column">{todo.description}</td>
                                <td className="assigned-to-column">{todo.assignedToName || 'Anyone'}</td>
                                <td className="date-due-column">{todo.dateDue ? moment(todo.dateDue).format('DD/MM/YYYY') : ''}</td>
                            </tr>
                        </React.Fragment>
                    )}
                </tbody>
            </table>
        );
    }

}

export default TodosTable;
